export default __webpack_public_path__ + "static/media/estudio-da-sobrancelha.0b69e414.jpg";